import styled from "styled-components";

const BoldText = styled.span`
  font-weight: 700;
`;

export default BoldText;
